import {Form, Formik} from "formik";
import React from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import LabelTradotta from "../../components/LabelTradotta";
import NsField from "../../components/fields/NsField";

export default function ModificaClasseMacrocategoriaView({
                                                             id,
                                                             show,
                                                             setShow,
                                                             modalMsg,
                                                             formikRef,
                                                             iconaDefault,
                                                             SignupSchema,
                                                             bottoniSx,
                                                             bottoniDx,
                                                             initialValuesForm,
                                                             onSubmitForm,
                                                         }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Card
                icon={'fas fa-tag'}
                title={id ? 'Modifica Classe Macrocategoria' : 'Inserisci Classe Macrocategoria'}
                bottoniSx={bottoniSx}
                bottoniDx={bottoniDx}
            >
                <Formik
                    initialValues={initialValuesForm}
                    innerRef={formikRef}
                    validationSchema={SignupSchema}
                    onSubmit={onSubmitForm}
                >
                    {({errors, touched, values, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-6">
                                <NsField
                                    name={"codice"}
                                    label={"Codice*:"}
                                    isDisabled={id}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"descrizione"}
                                    label={"Descrizione*:"}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"icona"}
                                    label={"Icona*:"}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-3">
                                <LabelTradotta htmlFor={"aicona"}>Anteprima icona:</LabelTradotta>
                                <div>
                                    <i className={values['icona'] !== '' ? values['icona'] : iconaDefault}/>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <LabelTradotta htmlFor={"aicona"}>Elenco icona:</LabelTradotta>
                                <div>
                                    <a
                                        href={"https://fontawesome.com/v5/search?o=r&m=free"}
                                        target={"_blank"}>Visita il sito di Font Awesome</a>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Card>
        </div>
    );
}